import { Component } from '@angular/core';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-toast',
  template: `
   <div class="toast-container position-fixed bottom-0 start-50 translate-middle-x p-3">
  <ngb-toast *ngFor="let msg of toastService.messages"
    [autohide]="true"
    [delay]="3000"
    [class]="'bg-' + msg.type + ' text-white'"
    (hidden)="remove(msg)">
    {{ msg.text }}
  </ngb-toast>
</div>

  `,
})
export class ToastComponent {
  constructor(public toastService: ToastService) {}

  remove(msg: any) {
    this.toastService.messages = this.toastService.messages.filter(m => m !== msg);
  }
}
